// extracted by mini-css-extract-plugin
export var news = "styles-module--news--2ULwI";
export var news_img = "styles-module--news_img--1WdHt";
export var news_inner = "styles-module--news_inner--L_iHX";
export var news_date = "styles-module--news_date--mlObr";
export var newstext_suptitle = "styles-module--newstext_suptitle--3KSMp";
export var newstext_title = "styles-module--newstext_title--2hlwp";